/* eslint-disable */
import { FunctionComponent, useState, useRef, useEffect } from 'react';
import styles from '../../../styles/components/pageComponents/manageUsers/MultiSelectDropdown.module.css';
import down from '../../../assets/profile/Vector (13).png';

export interface DropdownOption {
	label: string;
	value: string;
}

interface MultiSelectDropdownProps {
	options: DropdownOption[];
	selectedValues: string[];
	onChange: (values: string[]) => void;
	placeholder?: string;
	label?: string;
	disabled?: boolean;
	className?: string;
	width?: string;
}

const MultiSelectDropdown: FunctionComponent<MultiSelectDropdownProps> = ({
	options,
	selectedValues,
	onChange,
	placeholder = 'Select',
	label,
	disabled = false,
	className = '',
	width = '100%',
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef<HTMLDivElement>(null);

	const toggleDropdown = () => {
		if (!disabled) setIsOpen(prev => !prev);
	};

	const handleSelect = (value: string) => {
		if (selectedValues.includes(value)) {
			onChange(selectedValues.filter(v => v !== value));
		} else {
			onChange([...selectedValues, value]);
		}
	};

	// Close on outside click
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target as Node)
			) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () =>
			document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	const selectedLabels = options
		.filter(opt => selectedValues.includes(opt.value))
		.map(opt => opt.label)
		.join(', ');

	return (
		<div
			className={`${styles.container} ${className}`}
			style={{ width }}
			ref={dropdownRef}
		>
			{label && <label className={styles.label}>{label}</label>}

			<div
				className={`${styles.inputField} ${
					isOpen ? styles.active : ''
				} ${disabled ? styles.disabled : ''}`}
				onClick={toggleDropdown}
			>
				<span className={styles.text}>
					{selectedValues.length > 0 ? selectedLabels : placeholder}
				</span>
				<img
					src={down}
					alt="arrow"
					className={`${styles.arrow} ${isOpen ? styles.rotate : ''}`}
				/>
			</div>

			{isOpen && (
				<div className={styles.dropdown}>
					{options.map(option => {
						const isChecked = selectedValues.includes(option.value);
						return (
							<div
								key={option.value}
								className={styles.option}
								onClick={() => handleSelect(option.value)}
							>
								<div
									className={`${styles.checkbox} ${
										isChecked ? styles.checked : ''
									}`}
								>
									{isChecked && (
										<svg
											width="12"
											height="12"
											viewBox="0 0 24 24"
											fill="none"
										>
											<path
												d="M5 13L9 17L19 7"
												stroke="white"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
									)}
								</div>
								<span>{option.label}</span>
							</div>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default MultiSelectDropdown;
